import React from 'react';
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer } from 'recharts';

const tooltipStyle = {
    backgroundColor: '#1e293b',
    border: '1px solid #334155',
    borderRadius: 6,
    color: '#e2e8f0',
    fontSize: 12,
};

export default function RecipientStatsCard({ data }) {
    const barData = (data.per_survey || []).map(s => ({
        name: s.survey_name.length > 22 ? s.survey_name.slice(0, 20) + '…' : s.survey_name,
        recipients: s.count,
    }));

    return (
        <div style={styles.card}>
            <h3 style={styles.title}>Recipients</h3>
            <div style={styles.statsRow}>
                <BigStat value={data.total} label="Total" color="#14b8a6" />
                <BigStat value={data.participated} label="Participated" color="#22c55e" />
                <BigStat value={data.archived} label="Archived" color="#6b7280" />
            </div>
            {barData.length > 0 && (
                <div style={{ marginTop: 16 }}>
                    <span style={styles.subTitle}>Per Survey</span>
                    <ResponsiveContainer width="100%" height={barData.length * 32 + 16}>
                        <BarChart data={barData} layout="vertical" margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
                            <XAxis type="number" hide />
                            <Tooltip contentStyle={tooltipStyle} cursor={{ fill: 'rgba(255,255,255,0.05)' }} />
                            <Bar
                                dataKey="recipients"
                                fill="#14b8a6"
                                radius={[0, 4, 4, 0]}
                                barSize={18}
                                label={{ position: 'right', fill: '#CBD5E1', fontSize: 11 }}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                    {/* Render survey names separately since vertical BarChart YAxis is hard to style */}
                    <div style={styles.barLabels}>
                        {barData.map(d => (
                            <div key={d.name} style={styles.barLabel}>{d.name}</div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

function BigStat({ value, label, color }) {
    return (
        <div style={styles.bigStat}>
            <span style={{ fontSize: 28, fontWeight: 700, color }}>{typeof value === 'number' ? value.toLocaleString() : '—'}</span>
            <span style={styles.statLabel}>{label}</span>
        </div>
    );
}

const styles = {
    card: {
        background: '#1e3a5f',
        border: '1px solid #2d4a6f',
        borderRadius: 8,
        padding: 20,
    },
    title: {
        margin: 0,
        marginBottom: 12,
        fontSize: 14,
        fontWeight: 600,
        color: '#FFFFFF',
    },
    subTitle: {
        fontSize: 12,
        color: '#94A3B8',
        fontWeight: 500,
        marginBottom: 4,
        display: 'block',
    },
    statsRow: {
        display: 'flex',
        gap: 24,
    },
    bigStat: {
        display: 'flex',
        flexDirection: 'column',
    },
    statLabel: {
        fontSize: 12,
        color: '#94A3B8',
        marginTop: 2,
    },
    barLabels: {
        position: 'relative',
        marginTop: -999, // hidden — labels handled by chart
        display: 'none',
    },
    barLabel: {
        fontSize: 11,
        color: '#64748B',
    },
};
